import React from 'react';
import DetailTable from './DetailTable';
import DetailDescriptionP from './DetailDescriptionParagraph';
import DetailHowToPlay from './DetailHowToPlay';
import DetailOdds from './DetailOdds';
import DetailScratcher from './DetailScratcher';
import classNames from 'classnames';
import scratchers from '../../../scratchers';

const Detail = ({ view, changeView, previousView, scratcherDetail, incDetailPos, decDetailPos }) =>  {

  const detailClass = classNames({
    'scene': true,
    'scene--scratcher-detail': true,
    'scene--hidden': view !== 'detail'
  });

  let scratcher = {
    name: '',
    slug: '',
    description: [],
    image: '',
  }

  // get winning scratcher from sorted list of scratcher count
  const pos = scratchers.findIndex(scratcher => scratcher.slug === scratcherDetail);
  // if scratcher exits
  if(pos !== -1){
    scratcher = scratchers[pos];
  }

  const descriptionList = scratcher.description.map((description, i) => <DetailDescriptionP key={i} text={description} />);


  return (
    <div className={detailClass}>
      <div className="scene__content">
          <div className="scene__content-left">
              <h1 className="scene__tagline">{scratcher.name}</h1>
              {descriptionList}
              <h3 className="scene__title">How to Play</h3>
              <DetailHowToPlay text={scratcher.howToPlay} />
              <DetailTable rows={scratcher.table} slug={scratcher.slug} />
              <h3 className="scene__title  scene__title--small">Odds of Winning</h3>
              <DetailOdds text={scratcher.odds} />
              <p className="scene__p">Odds of winning are established when a game is printed. Number of winning tickets remaining will change as players win prizes. For more information on odds, <a target="_blank" href="https://www.valottery.com/faq/?keyword=listall">Click Here</a>.</p>
          </div>
          <DetailScratcher
            scratcher={scratcher}
            incDetailPos={incDetailPos}
            decDetailPos={decDetailPos}
            previousView={previousView}
            changeView={changeView}
            view={view}
          />
      </div>
  </div>
  );
}

export default Detail;



/** WEBPACK FOOTER **
 ** ./src/components/Scenes/Detail/Detail.js
 **/